// selectors.js
import { createSelector } from 'reselect';

const getMaterialData = (state) => state.MaterialData.material;
const getEmployeeData = (state) => state.EmployeeData.employee;
const getMatInwardData = (state) => state.MatInwardData.stkValue;
const getPatternMatchReg = (state) => state.PatternMatchData.patMat;

export const selectMaterials = createSelector(
  [getMaterialData],
  (material) => material || { data: [] }
);

export const selectEmployees = createSelector(
  [getEmployeeData],
  (employee) => employee || { data: [] }
);

export const selectMatInwardData = createSelector(
  [getMatInwardData],
  (stkValue) => stkValue || { data: [] }
);


export const selectPatternMatchReg = createSelector(
  [getPatternMatchReg],
  (stkValue) => stkValue || { data: [] }
);

const getRetailerReg = (state) => state.retailerData.redata;
export const selectRetailerReg = createSelector(
  [getRetailerReg],
  (stkValue) => stkValue || { data: [] }
);

const getTeamLeader = (state) => state.TeamLeaderDatalist.teamLeader;
export const selectTeamLeaderReg = createSelector(
  [getTeamLeader],
  (stkValue) => stkValue || { data: [] }
);